import React from 'react';
import { Flex, Button, Image, theme } from 'antd';
import { useWeb3ModalAccount } from '@web3modal/ethers/react'
import { DashboardIcon, TwitterIcon, TelegramIcon, SupportIcon, DocsIcon, BulbIcon, AirdropIcon } from '../shared/ApeIcons'
import { SidebarChainSelect } from '../shared/SidebarChainSelect'
import { useNavigate, useLocation } from "react-router-dom";
import { CloseOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { ConnectMenuButton } from '../shared/ConnectButton';
import { usePermissions } from '../context/PermissionsContext';
import { useTheme } from '../context/ThemeContext';
import { playSound } from '../../lib/effects';
const { Text, Link } = Typography;

const LeaderboardIcon = (props) => (
	<svg width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 6l1.5 3.5L17 11l-3.5 1.5L12 16l-1.5-3.5L7 11l3.5-1.5L12 6z" fill={props.color || 'currentColor'} />
		<path d="M6 17h12v2H6zM8 19h8v3H8z" fill={props.color || 'currentColor'} opacity="0.8" />
	</svg>
);


const MenuItem = ({ item, index, handleMenuClick, dark }) => {
	const { pathname } = useLocation();
	const selected = pathname === item.key;
	return (
		<Link
			onClick={() => { handleMenuClick(item, index) }}
			style={{
				display: "flex",
				alignItems: "center",
				padding: "10px 10px",
				gap: '12px',
				borderRadius: '9px',
				border: `2px solid ${selected ? 'var(--accent)' : 'transparent'}`,
				background: selected ? 'var(--accent-wash, rgba(214, 254, 82, 0.14))' : 'transparent',
				transition: 'transform 100ms, box-shadow 100ms, background 100ms, border-color 100ms',
				textDecoration: 'none',
				cursor: item.disabled ? 'not-allowed' : 'pointer',
				opacity: item.disabled ? 0.4 : 1
			}}
			onMouseEnter={(e) => {
				if (!selected) {
					e.currentTarget.style.borderColor = 'rgba(244, 241, 232, 0.45)';
					e.currentTarget.style.background = 'rgba(244, 241, 232, 0.07)';
				}
			}}
			onMouseLeave={(e) => {
				if (!selected) {
					e.currentTarget.style.borderColor = 'transparent';
					e.currentTarget.style.background = 'transparent';
				}
			}}
		>
			<span style={{ display: 'inline-flex', width: '24px', justifyContent: 'center' }}>
				<item.icon color={selected ? 'var(--accent)' : '#f4f1e8'} style={{ fontSize: "20px" }} />
			</span>
			<Text style={{
				color: '#f4f1e8',
				fontWeight: 700,
				fontSize: "20px",
				overflow: 'hidden',
				textWrap: 'nowrap',
				fontFamily: 'var(--font-display)',
				letterSpacing: '0.6px'
			}}>
				{item.label}
			</Text>
		</Link>
	);
}

export const LeftMenu = ({ mobile, menuCollapsed, setMenuCollapsed, handleChainChange, chainId }) => {
	const navigate = useNavigate();
	const { isAdmin, isAuthenticated, authenticate } = usePermissions();
	const { dark, toggleTheme } = useTheme();

	const handleMenuClick = (item, index) => {
		if (item.disabled) return;
		playSound('click');
		if (item.external) {
			window.open(item.key, '_blank', 'noopener,noreferrer');
		} else {
			navigate(item.key);
		}
		if (mobile) setMenuCollapsed(true);
	};

	const menuItems = [
		{ key: "/new-pairs", icon: DashboardIcon, label: "New pairs" },
		{ key: "/airdrop", icon: AirdropIcon || DashboardIcon, label: "Airdrop", disabled: true },
		{ key: "https://ape-store.gitbook.io/ape.store-docs", icon: DocsIcon, label: "Docs", external: true },
		{ key: "/einstein", icon: BulbIcon, label: "Smort Apez", adminOnly: true }
	];

	return (
		<Flex vertical style={{ width: '100%', height: '100%', padding: '26px 20px', gap: '8px' }}>
			<Flex justify="space-between" align="center" style={{ width: '100%' }}>
				<Link onClick={() => { navigate("/"); if (mobile) setMenuCollapsed(true); }} style={{ width: '100%', marginBottom: '20px' }}>
					<Flex justify="center" align="left" vertical style={{ gap: '4px', cursor: 'pointer' }}>
						<Image preview={false} width={84} src="/img/logo.png" style={{ marginLeft: '2px' }} />
						<Typography style={{
							fontWeight: 800,
							fontFamily: 'var(--font-display)',
							fontSize: '31px',
							letterSpacing: '1px',
							color: '#f4f1e8',
							lineHeight: 1,
							overflow: 'hidden',
							textWrap: 'nowrap'
						}}>ape.store</Typography>
						<div style={{
							height: '4px',
							width: '120px',
							background: 'var(--accent)',
							borderRadius: '3px',
							transform: 'rotate(-1.2deg)'
						}}></div>
					</Flex>
				</Link>

				{mobile &&
					<Button
						type="text"
						icon={<CloseOutlined />}
						onClick={() => setMenuCollapsed(true)}
						style={{ fontSize: '16px', width: 64, height: 64, color: '#f4f1e8' }}
					/>
				}
			</Flex>

			<div style={{ padding: '0 0 6px 0' }}>
				<button
					onClick={() => { navigate('/new-token'); if (mobile) setMenuCollapsed(true); }}
					style={{
						fontFamily: 'var(--font-display)',
						width: '100%',
						fontWeight: 800,
						fontSize: '22px',
						letterSpacing: '0.5px',
						background: 'var(--accent)',
						color: dark ? '#111' : 'var(--color-carbon)',
						border: dark ? '3px solid rgba(244,241,232,.25)' : '3px solid #f4f1e8',
						outline: dark ? '2px solid rgba(244,241,232,.15)' : '2px solid #000',
						outlineOffset: '-6px',
						borderRadius: '11px 8px 12px 9px',
						transition: 'transform 0.12s, box-shadow 0.12s',
						padding: '14px 10px',
						cursor: 'pointer',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '9px',
						transform: 'rotate(-1deg) scale(1.03)',
						boxShadow: dark ? 'rgba(0,0,0,.35) 4px 4px 0px' : 'rgba(244, 241, 232, 0.25) 4px 4px 0px',
						lineHeight: 1.1
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.transform = 'rotate(0deg) scale(1)';
						e.currentTarget.style.boxShadow = 'none';
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.transform = 'rotate(-1deg) scale(1.03)';
						e.currentTarget.style.boxShadow = 'rgba(244, 241, 232, 0.25) 4px 4px 0px';
					}}
				>
					<img src="/img/bolt.png" width={20} height={24} alt="" style={{ display: 'block', objectFit: 'contain' }} />
					CREATE A TOKEN
				</button>
			</div>

			<nav style={{ marginTop: '14px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
				{menuItems.map((item, index) => {
					return item.adminOnly && (isAdmin === false || isAuthenticated === false) ?
						<div key={item.key}></div> :
						<MenuItem key={item.key} item={item} index={index} handleMenuClick={handleMenuClick} dark={dark} />;
				})}
				{isAdmin && isAuthenticated === false ?
					<Link onClick={authenticate} style={{ display: "flex", alignItems: "center", padding: "10px" }}>
						<Text style={{ color: "red", fontWeight: 500, fontSize: "17px", marginLeft: "20px", overflow: 'hidden', textWrap: 'nowrap' }}>Authenticate</Text>
					</Link> :
					<></>}
			</nav>

			<div style={{ flex: 1 }} />

			{mobile && menuCollapsed ? <></> :
				<>
					<Flex align="center" justify="start" gap={12} style={{ padding: '0 4px', marginBottom: '14px' }}>
						<button
							onClick={toggleTheme}
							title={dark ? "Switch to light mode" : "Switch to dark mode"}
							style={{
								cursor: 'pointer',
								border: dark ? '2px solid rgba(244,241,232,.3)' : 'none',
								borderRadius: '9px',
								background: dark ? 'rgba(244,241,232,.06)' : 'none',
								padding: '4px',
								lineHeight: 0, transition: 'transform 160ms',
								color: '#f4f1e8'
							}}
							onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.14) rotate(-7deg)'; }}
							onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
						>
							{dark ? (
								<svg width={26} height={26} viewBox="0 0 24 24" fill="none">
									<circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" />
									<path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
								</svg>
							) : (
								<svg width={26} height={26} viewBox="0 0 24 24" fill="none">
									<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							)}
						</button>
						<div style={{ flex: 1 }} />
						<SidebarChainSelect chainId={chainId} onChainChange={handleChainChange} />
					</Flex>

					<div style={{
						height: '2px',
						margin: '0 6px 16px',
						background: 'rgba(244, 241, 232, 0.35)',
						transform: 'rotate(-0.6deg)'
					}} />

					<ConnectMenuButton />

					<Flex align="center" justify="start" gap={0} style={{ marginTop: '14px', paddingLeft: '2px' }}>
						<a href="https://twitter.com/apedotstore" target="_blank" rel="noopener noreferrer" title="Follow on X"
							style={{
								display: 'inline-flex', height: '30px', width: '30px', alignItems: 'center', justifyContent: 'center',
								borderRadius: '8px', color: 'rgba(244, 241, 232, 0.75)', transition: 'color 120ms, background 120ms, transform 120ms',
								textDecoration: 'none'
							}}
							onMouseEnter={(e) => { e.currentTarget.style.color = '#f4f1e8'; e.currentTarget.style.background = 'rgba(244, 241, 232, 0.09)'; e.currentTarget.style.transform = 'scale(1.05) rotate(-3deg)'; }}
							onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(244, 241, 232, 0.75)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'none'; }}
						>
							<TwitterIcon width={17} height={17} color="currentColor" />
						</a>
						<a href="https://t.me/apedotstore" target="_blank" rel="noopener noreferrer" title="Telegram"
							style={{
								display: 'inline-flex', height: '30px', width: '30px', alignItems: 'center', justifyContent: 'center',
								borderRadius: '8px', color: 'rgba(244, 241, 232, 0.75)', transition: 'color 120ms, background 120ms, transform 120ms',
								textDecoration: 'none'
							}}
							onMouseEnter={(e) => { e.currentTarget.style.color = '#f4f1e8'; e.currentTarget.style.background = 'rgba(244, 241, 232, 0.09)'; e.currentTarget.style.transform = 'scale(1.05) rotate(3deg)'; }}
							onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(244, 241, 232, 0.75)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'none'; }}
						>
							<TelegramIcon width={17} height={17} color="currentColor" />
						</a>
						<a href="https://t.me/ApeStoreSupport" target="_blank" rel="noopener noreferrer" title="Support"
							style={{
								display: 'inline-flex', height: '30px', width: '30px', alignItems: 'center', justifyContent: 'center',
								borderRadius: '8px', color: 'rgba(244, 241, 232, 0.75)', transition: 'color 120ms, background 120ms, transform 120ms',
								textDecoration: 'none'
							}}
							onMouseEnter={(e) => { e.currentTarget.style.color = '#f4f1e8'; e.currentTarget.style.background = 'rgba(244, 241, 232, 0.09)'; e.currentTarget.style.transform = 'scale(1.05) rotate(-3deg)'; }}
							onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(244, 241, 232, 0.75)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'none'; }}
						>
							<SupportIcon width={17} height={17} color="currentColor" />
						</a>
					</Flex>
				</>
			}
		</Flex>
	);
}
